// Lightweight environment sniffing for the location-permission help UI.
// UA sniffing is a last resort in general, but "which settings screen do
// I send this person to" genuinely depends on it.

export const isIOS = () =>
  /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
  // iPadOS 13+ reports as Mac with touch support
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

// In-app browsers (Instagram, Messenger, TikTok, etc.) frequently cannot
// show a geolocation prompt at all — the fix is "open in a real browser"
export const isInAppBrowser = () =>
  /FBAN|FBAV|FB_IAB|Instagram|Snapchat|TikTok|musical_ly|Line\/|MicroMessenger|Twitter/i.test(
    navigator.userAgent
  );
